// extracted by mini-css-extract-plugin
export default {"columns":"UsersColumns_columns__4LBaj"};